import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericNumberInput } from '../../components';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';
import { useInputBlurAction } from '../../hooks';
import { useAppStore } from '../../stores';

const UnderwritingYearInput: InputWithoutSource = ({ input }) => {
    const { actionStore } = useAppStore();

    const { handleFocus, handleBlur, handleKeyDown } = useInputBlurAction(input, () =>
        actionStore.changeUnderwritingYear(input.worksheetId, input.nodeId)
    );

    return (
        <GenericNumberInput
            label={input.name}
            input={input}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
        />
    );
};

UnderwritingYearInput.meta = {
    inputType: InputModel.name
};

export default observer(UnderwritingYearInput);
